import React from 'react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';

export const ChildTooltip = ({
  title,
  children,
  asChild,
}: {
  title: string;
  children: JSX.Element;
  asChild?: boolean;
}) => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger className="flex cursor-auto" asChild={asChild}>
          {children}
        </TooltipTrigger>
        <TooltipContent className="max-w-xs">{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
